import React from 'react';
import { TimelineItemGradient } from '../../';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const GradientItem: React.FC<Props> = ({ item, isSimple, isExpanded }) => (
  <TimelineItemGradient
    key={item.id}
    item={item}
    isSimple={isSimple}
    isExpanded={isExpanded}
  />
);

export default GradientItem;
